import PrintIcon from "@mui/icons-material/Print";
import VisibilityIcon from "@mui/icons-material/Visibility";
import React from "react";

const ViewPrintIcon = () => {
  return (
    <span
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "Center",
        alignItems: "Center",
        marginLeft: "5px"
      }}
    >
      <PrintIcon style={{ fontSize: 16 }} />
      <VisibilityIcon style={{ fontSize: 12, marginTop: -8, marginRight: -6 }} />
    </span>
  );
};

export default ViewPrintIcon;
